import { ArdoqIcon, ArdoqIconCategory, IconSize } from '@ardoq/icons';
import { s24 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { EntityIcon } from '@ardoq/basic-components';
import { TextOverflow } from '@ardoq/popovers';
import { FlexBox } from '@ardoq/layout';

export type ComponentDecoratorAsIconProps = {
  shadedColor: string;
  lightenedColor: string;
  contrastColor: string;
  icon: ArdoqIcon;
  value: string;
  isImage: boolean;
  label?: string;
};

export const ComponentDecoratorAsIcon = ({
  shadedColor,
  lightenedColor,
  contrastColor,
  icon,
  value,
  isImage,
  label,
}: ComponentDecoratorAsIconProps) => {
  return (
    <FlexBox align="center" gap="small">
      <EntityIconContainer
        $borderColor={shadedColor}
        $backgroundColor={lightenedColor}
      >
        <EntityIcon
          imageSrc={isImage ? value : undefined}
          iconId={
            icon.category === ArdoqIconCategory.FontAwesome || icon.isSVG
              ? icon.id
              : undefined
          }
          iconSize={IconSize.SMALL}
          color={contrastColor}
        />
      </EntityIconContainer>
      {label ? (
        <TextOverflow>
          <span style={{ color: contrastColor }}>{label}</span>
        </TextOverflow>
      ) : null}
    </FlexBox>
  );
};

export const EntityIconContainer = styled.div<{
  $borderColor: string;
  $backgroundColor: string;
}>`
  background-color: ${props => props.$backgroundColor};
  border-radius: 100%;
  border: 1px solid ${props => props.$borderColor};
  display: flex;
  width: ${s24};
  height: ${s24};
  align-items: center;
  justify-content: center;
  margin: 0;
  flex-shrink: 0;
`;
